import { useState } from 'react';
import { Grid } from 'antd';
import { useAssetOverview } from '~/app/hooks/asset/useAssetOverview';
import { AssetOverviewView } from './AssetOverviewView';
import { AssetCreateModal } from './AssetCreateModal/AssetCreateModal';

const { useBreakpoint } = Grid;

export function AssetOverview() {
  const screens = useBreakpoint();
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const {
    assets,
    assetModels,
    assetTypes,
    error,
    isLoading,
    isFetching,
    isLoadingAssetModels,
    isLoadingAssetTypes,
    pagination,
    searchValue,
    selectedAssetModelId,
    selectedAssetTypeId,
    handleAssetModelChange,
    handleAssetTypeChange,
    handleSearchChange,
    handleTableChange,
    refetch,
  } = useAssetOverview();

  const assetTypeOptions = assetTypes.map((assetType) => ({
    label: assetType.name,
    value: assetType.id,
  }));

  const assetModelOptions = assetModels.map((assetModel) => ({
    label: assetModel.name,
    value: assetModel.id,
  }));

  const hasActiveFilters = Boolean(selectedAssetTypeId || selectedAssetModelId);

  return (
    <>
      <AssetOverviewView
        assetModelOptions={assetModelOptions}
        assetModels={assetModels}
        assets={assets}
        assetTypeOptions={assetTypeOptions}
        error={error}
        hasActiveFilters={hasActiveFilters}
        isFetching={isFetching}
        isLoading={isLoading}
        isLoadingAssetModels={isLoadingAssetModels}
        isLoadingAssetTypes={isLoadingAssetTypes}
        isWideLayout={Boolean(screens.sm)}
        onAddAssetAction={() => setIsCreateModalVisible(true)}
        onAssetModelChangeAction={handleAssetModelChange}
        onAssetTypeChangeAction={handleAssetTypeChange}
        onClearFiltersAction={() => {
          handleAssetTypeChange('');
          handleAssetModelChange('');
        }}
        onRefreshAction={() => {
          void refetch();
        }}
        onSearchChangeAction={handleSearchChange}
        onTableChangeAction={handleTableChange}
        pagination={pagination}
        searchValue={searchValue}
        selectedAssetModelId={selectedAssetModelId}
        selectedAssetTypeId={selectedAssetTypeId}
      />
      <AssetCreateModal
        visible={isCreateModalVisible}
        onCancel={() => setIsCreateModalVisible(false)}
        onSuccess={() => {
          setIsCreateModalVisible(false);
          void refetch();
        }}
      />
    </>
  );
}
